import { Star } from "lucide-react";
import { BRAND, RATING_BREAKDOWN, REVIEWS } from "@/lib/content";
import { useReveal } from "@/lib/useReveal";

const Stars = ({ n }) => (
  <div className="flex">
    {[0, 1, 2, 3, 4].map((i) => (
      <Star
        key={i}
        className={`h-4 w-4 ${i < n ? "fill-amber-400 text-amber-400" : "text-neutral-300"}`}
      />
    ))}
  </div>
);

export const Reviews = () => {
  const { ref, inView } = useReveal();
  return (
    <section className="bg-white py-12 sm:py-16 lg:py-20" ref={ref}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <h2
          className={`mb-10 text-center font-display text-3xl uppercase text-neutral-900 sm:text-4xl hp-reveal ${
            inView ? "in-view" : ""
          }`}
        >
          Customer Reviews
        </h2>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* Summary */}
          <div className="lg:col-span-4">
            <div className="rounded-2xl border border-neutral-200 bg-[var(--hp-page)] p-6 text-center">
              <div className="font-num text-6xl font-bold text-[var(--hp-crimson)]">
                {BRAND.rating}
              </div>
              <div className="mt-1 flex justify-center">
                <Stars n={5} />
              </div>
              <p className="mt-2 text-sm text-neutral-600">
                Based on {BRAND.reviewCount.toLocaleString("en-IN")}+ reviews
              </p>
              <div className="mt-5 space-y-2">
                {RATING_BREAKDOWN.map((r) => (
                  <div key={r.stars} className="flex items-center gap-2 text-xs">
                    <span className="w-8 font-semibold text-neutral-600">{r.stars}★</span>
                    <div className="h-2 flex-1 overflow-hidden rounded-full bg-neutral-200">
                      <div
                        className="h-full rounded-full bg-amber-400"
                        style={{ width: `${r.pct}%` }}
                      />
                    </div>
                    <span className="w-10 text-right text-neutral-500">{r.pct}%</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Review cards */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-8">
            {REVIEWS.map((rv, i) => (
              <div
                key={i}
                data-testid={`review-card-${i}`}
                className={`rounded-2xl border border-neutral-200 p-5 hp-reveal ${
                  inView ? "in-view" : ""
                }`}
                style={{ animationDelay: `${i * 0.08}s` }}
              >
                <div className="flex items-center justify-between">
                  <Stars n={rv.rating} />
                  <span className="rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-bold text-emerald-700">
                    Verified Buyer
                  </span>
                </div>
                <h3 className="mt-3 font-bold text-neutral-900">{rv.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-neutral-600">{rv.text}</p>
                <div className="mt-4 flex items-center gap-2">
                  <img
                    src={rv.img}
                    alt={rv.name}
                    className="h-9 w-9 rounded-full object-cover ring-2 ring-[var(--hp-crimson)]/20"
                  />
                  <div className="text-xs">
                    <div className="flex items-center gap-1 font-semibold text-neutral-800">
                      {rv.name}
                    </div>
                    <div className="text-neutral-500">{rv.city}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
